// src/pages/License.js
import React from "react";
import "../App.css";

const License = () => {
  return (
    <section className="legal-page">
      <header className="legal-hero">
        <h1 className="legal-hero-title">License Agreement</h1>
        <p className="legal-hero-subtitle">
          Terms governing the use of Ndils Daily Care branding, content and
          digital materials.
        </p>
        <p className="legal-meta">Last updated: November 2025</p>
      </header>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Website Content License</h2>
          <p>
            All content on this website, including text, imagery, layout and
            branding, is protected by intellectual property laws. You are
            granted a limited, non-exclusive, non-transferable license to view
            and print pages for personal, non-commercial use only.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Restrictions</h2>
          <ul className="legal-list">
            <li>You may not copy or redistribute our content for resale.</li>
            <li>
              You may not use the Ndils Daily Care name or logo without written
              permission.
            </li>
            <li>
              You may not modify or reverse engineer any part of the website or
              digital materials.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Third-Party Materials</h2>
          <p>
            Some images, icons or tools used on this website may be licensed
            from third parties (for example, stock photography providers). Those
            materials are subject to their own licensing terms and may not be
            reused without the original owner’s consent.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Termination</h2>
          <p>
            Ndils Daily Care reserves the right to withdraw or modify this
            license at any time if you breach these terms or use our materials
            in a way that could harm our clients, staff or reputation.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Contact</h2>
          <p>
            For any questions about using our logo, content or materials, please
            contact us through the Contact page so we can review your request.
          </p>
        </section>
      </div>
    </section>
  );
};

export default License;
